import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AppContextService } from './app-context.service';

@Injectable({
  providedIn: 'root',
})
export class AppContextResolver {
  constructor(private _contextService: AppContextService) {}

  public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    this._contextService.setContext(route.data.context);
  }
}
